'use strict';


function __(tag, block) {
  block.tag = tag;
  return block;
}

exports.__ = __;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// /home/circleci/project/node_modules/bs-platform/lib/js/block.js
// module id = 144
// module chunks = 0